import { Injectable } from '@angular/core';
import { HttpService } from './helpers/http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorService } from './helpers/error.service';

import { Offer, OfferDetails } from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class OfferService {
  constructor(private httpService: HttpService,
    private errorService: ErrorService) { }

  getAll(currentUserId: number, userId: number, statusId: string, offerKindId: string, dateStart: Date, dateEnd: Date, name: string, skip: number, take: number): Observable<Offer[]> {
    return this.httpService.sendPost('offers/get-all', {
      CurrentUserId: currentUserId,
      UserId: userId,
      StatusId: statusId,
      OfferKindId: offerKindId,
      DateStart: dateStart,
      DateEnd: dateEnd,
      Name: name,
      Skip: skip,
      Take: take
    })
      .pipe(map(response => {
        return this.errorService.processResponseForErrors(response);
      }));
  }

  getCount(currentUserId: number, userId: number, statusId: string, offerKindId: string, dateStart: Date, dateEnd: Date, name: string): Observable<number> {
    return this.httpService.sendPost('offers/get-count', {
      CurrentUserId: currentUserId,
      UserId: userId,
      StatusId: statusId,
      OfferKindId: offerKindId,
      DateStart: dateStart,
      DateEnd: dateEnd,
      Name: name
    })
      .pipe(map(response => {
        return this.errorService.processResponseForErrors(response);
      }));
  }

  get(id: number): Observable<OfferDetails> {
    return this.httpService.sendGet('offers/get?id=' + id)
      .pipe(map(response => {
        return this.errorService.processResponseForErrors(response);
      }));
  }

  delete(id: number): Observable<boolean> {
    return this.httpService.sendGet('offers/delete?id=' + id)
      .pipe(map(response => {
        return this.errorService.processResponseForErrors(response);
      }));
  }

  save(formData: FormData) {
    return this.httpService.sendPost('offers/save', formData)
      .pipe(map(result => {
        return result;
      }));
  }

  saveStatus(offerId: number, userId: number, statusId: number) {
    return this.httpService.sendPost('offers/save-status?offerId=' + offerId + '&userId=' + userId + '&statusId=' + statusId, {})
      .pipe(map(result => {
        return result;
      }));
  }
}
